export var Sector;
(function (Sector) {
    Sector["ADVANCED_MATERIALS"] = "Advanced Materials";
    Sector["AEROSPACE"] = "Aerospace";
    Sector["AI"] = "Artificial Intelligence";
    Sector["APPLIEDAI"] = "Applied AI";
    Sector["APPLIEDPHYSICS"] = "Applied Physics";
    Sector["BIOTECH"] = "Biotech";
    Sector["BLOCKCHAIN"] = "Blockchain";
    Sector["CLOUD_DATA_INFRASTRUCTURE"] = "Cloud & Data Infrastructure";
    Sector["COMMERCE"] = "Commerce";
    Sector["CONSTRUCTION"] = "Construction";
    Sector["CONSUMER"] = "Consumer";
    Sector["CONSUMER_TECHNOLOGY"] = "Consumer Technology";
    Sector["CYBER_SEC"] = "Cyber Security";
    Sector["C_AND_D"] = "Content & Design";
    Sector["DATA_DRIVEN_HEALTH"] = "Data-Driven Health";
    Sector["DEEPTECH"] = "DeepTech";
    Sector["DEVOPS"] = "DevOps";
    Sector["EDTECH"] = "Edtech";
    Sector["EDU"] = "Education";
    Sector["ENERGY"] = "Energy";
    Sector["ENTERPRISE_SOFTWARE"] = "Enterprise Software";
    Sector["FINTECH"] = "Fintech";
    Sector["FIN_SERVICES"] = "Financial Services";
    Sector["FOODTECH"] = "Foodtech";
    Sector["FUTUREOFWORK"] = "Future of work";
    Sector["GAMING"] = "Gaming";
    Sector["HEALTHCARE"] = "Healthcare";
    Sector["HEALTHTECH"] = "Healthtech";
    Sector["HR"] = "HR";
    Sector["HRTECH"] = "HRtech";
    Sector["INDUSTRIAL"] = "Industrial Applications";
    Sector["INSURTECH"] = "Insurtech";
    Sector["IOT"] = "IoT";
    Sector["LIFE_SCI"] = "Life Sciences";
    Sector["LOGISTICS"] = "Logistics";
    Sector["MARKETING_TECH"] = "Marketing Tech";
    Sector["MEDIA"] = "Media";
    Sector["MIDDLEWARE"] = "Middleware";
    Sector["MOBILITY"] = "Mobility";
    Sector["NEXT_GEN_MEDIA"] = "Next Gen Media";
    Sector["PHOTONICS"] = "Photonics";
    Sector["PRODUCTTOOLS"] = "Product Tools";
    Sector["PROPTECH"] = "Proptech";
    Sector["REAL_ESTATE"] = "Real Estate";
    Sector["RETAILTECH"] = "Retail Tech";
    Sector["REV_OPS"] = "RevOps";
    Sector["ROBOTICS"] = "Robotics";
    Sector["SAAS"] = "SaaS";
    Sector["SALES"] = "Sales";
    Sector["SALES_ENAB"] = "Sales Enablement";
    Sector["SECURITY"] = "Security";
    Sector["SPORTS"] = "Sports";
    Sector["SUSTAINABILITY"] = "Sustainability";
    Sector["TELECOMS"] = "Telecommunications";
    Sector["TRANSPORT"] = "Transport";
    Sector["TRAVEL"] = "Travel";
    Sector["UTILITIES"] = "Utilities";
    Sector["VERTICALSAAS"] = "Vertical SaaS";
    Sector["WEB3"] = "Web3";
    Sector["OTHER"] = "Other";
})(Sector || (Sector = {}));
export var Stage;
(function (Stage) {
    Stage["PRE_SEED"] = "Pre-seed";
    Stage["PRE_SEED_EXTENSION"] = "Pre-seed extension";
    Stage["EARLY_SEED"] = "Early seed";
    Stage["SEED"] = "Seed";
    Stage["LATE_SEED"] = "Late seed";
    Stage["SEED_EXTENSION"] = "Seed extension";
    Stage["PRE_SERIES_A"] = "Pre-Series A";
    Stage["SERIES_A"] = "Series A";
    Stage["SERIES_A_BRIDGE"] = "Series A bridge";
    Stage["SERIES_B"] = "Series B";
    Stage["SERIES_B_BRIDGE"] = "Series B bridge";
    Stage["SERIES_C"] = "Series C";
    Stage["SERIES_C_BRIDGE"] = "Series C bridge";
    Stage["SERIES_D"] = "Series D";
    Stage["SERIES_E"] = "Series E";
    Stage["SERIES_F_PLUS"] = "Series F+";
    Stage["GROWTH"] = "Growth";
    Stage["PRE_IPO"] = "Pre-IPO";
    Stage["LEVERAGED_BUYOUT"] = "Leveraged buyout";
    Stage["DISTRESSED"] = "Distressed";
    Stage["SECONDARY"] = "Secondary";
    Stage["MEZZANINE"] = "Mezzanine";
    Stage["OTHER"] = "Other";
})(Stage || (Stage = {}));
//# sourceMappingURL=api.js.map